// extracted by mini-css-extract-plugin
export var orderDetails = "_o7-2";
export var orderImage = "_o7-1";
export var orderMeta = "_o7-3";
export var orderSummary = "_o7-0";
export var rightArrow = "_o7-4";